import React, { useEffect, useState, useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { listRazorpayTransactions } from "../api";

const STATES = ["", "INITIATED", "NOTIFIED", "SUCCESS", "FAILED", "CANCELLED"];

const STATE_STYLE = {
  SUCCESS:    { bg: "#dcfce7", color: "#166534" },
  INITIATED:  { bg: "#dbeafe", color: "#1e40af" },
  NOTIFIED:   { bg: "#dbeafe", color: "#1e40af" },
  FAILED:     { bg: "#fee2e2", color: "#991b1b" },
  CANCELLED:  { bg: "#f1f5f9", color: "#475569" },
};

function Badge({ state }) {
  const style = STATE_STYLE[state] || { bg: "#f1f5f9", color: "#475569" };
  return (
    <span style={{ ...t.badge, backgroundColor: style.bg, color: style.color }}>{state}</span>
  );
}

function fmtAmount(paise) {
  return `₹${(paise / 100).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;
}

function fmtDate(val) {
  if (!val) return "—";
  return new Date(val).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export default function RazorpayPayments() {
  const { app } = useOutletContext();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stateFilter, setStateFilter] = useState("");

  const load = useCallback(() => {
    setLoading(true);
    listRazorpayTransactions(app.id, { state: stateFilter || null })
      .then(setRows)
      .finally(() => setLoading(false));
  }, [app.id, stateFilter]);

  useEffect(() => { load(); }, [load]);

  return (
    <div style={s.wrap}>
      <h1 style={s.h1}>Payments</h1>
      <p style={s.sub}>{app.name} · Razorpay</p>

      <div style={s.filters}>
        <select value={stateFilter} onChange={(e) => setStateFilter(e.target.value)} style={s.select}>
          {STATES.map((st) => (
            <option key={st} value={st}>{st || "All states"}</option>
          ))}
        </select>
        <span style={s.count}>{loading ? "…" : `${rows.length} results`}</span>
      </div>

      {loading ? (
        <div style={s.loading}>Loading...</div>
      ) : rows.length === 0 ? (
        <div style={s.empty}>No payments found.</div>
      ) : (
        <div style={t.wrapper}>
          <table style={t.table}>
            <thead>
              <tr>
                {["Order Ref", "Subscription", "Amount", "State", "Razorpay Payment ID", "Created"].map((h) => (
                  <th key={h} style={t.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.id} style={i % 2 !== 0 ? { backgroundColor: "#fafafa" } : {}}>
                  <td style={t.td}><code style={t.mono}>{row.id.slice(0, 20)}…</code></td>
                  <td style={t.td}><code style={t.mono}>{row.subscription_id.slice(0, 12)}…</code></td>
                  <td style={t.td}>{fmtAmount(row.amount)}</td>
                  <td style={t.td}><Badge state={row.state} /></td>
                  <td style={t.td}>{row.razorpay_payment_id || "—"}</td>
                  <td style={t.td}>{fmtDate(row.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const s = {
  wrap: {},
  h1: { margin: "0 0 4px", fontSize: 22, fontWeight: 700, color: "#1e293b" },
  sub: { margin: "0 0 24px", fontSize: 14, color: "#64748b" },
  filters: { display: "flex", alignItems: "center", gap: 10, marginBottom: 16 },
  select: { padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, backgroundColor: "#fff" },
  count: { marginLeft: "auto", fontSize: 13, color: "#94a3b8" },
  loading: { color: "#64748b", padding: 20 },
  empty: { textAlign: "center", padding: "60px 0", color: "#64748b", fontSize: 14 },
};

const t = {
  wrapper: { overflowX: "auto", borderRadius: 10, boxShadow: "0 1px 3px rgba(0,0,0,0.07)" },
  table: { width: "100%", borderCollapse: "collapse", backgroundColor: "#fff", fontSize: 13 },
  th: { padding: "10px 14px", textAlign: "left", backgroundColor: "#f8fafc", color: "#64748b", fontWeight: 600, fontSize: 11, textTransform: "uppercase", letterSpacing: "0.05em", borderBottom: "1px solid #f1f5f9", whiteSpace: "nowrap" },
  td: { padding: "11px 14px", color: "#1e293b", borderBottom: "1px solid #f8fafc", verticalAlign: "middle" },
  badge: { display: "inline-block", padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 600 },
  mono: { fontSize: 11, backgroundColor: "#f1f5f9", padding: "2px 5px", borderRadius: 4 },
};
